// BFF: ○ gap — legacy providersWorkUnitsInbox. No bff/crm module for the inbox.
export { default } from './Inbox'
